import { Routes } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DashboardComparisonComponent } from './dashboard-comparison/dashboard-comparison.component';
import { AuthGuard } from './shared/guards/auth.guard';
// Using custom override - bar chart with pink/red color
// import { BarChartComponent } from '@custom';
import { ChatComponent } from '@shared-lib/global-components/chat/chat.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },

  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'dashboard-config.json' },
  },
  {
    path: 'all-charts',
    redirectTo: 'all-chart-1',
    pathMatch: 'full',
  },
  {
    path: 'all-chart-1',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'all-chart-1.json' },
  },
  {
    path: 'all-chart-2',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'all-chart-2.json' },
  },
  {
    path: 'all-chart-3',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'all-chart-3.json' },
  },
  {
    path: 'test',
    component: DashboardComparisonComponent,
    canActivate: [AuthGuard],
  },

   {
    path: 'all-charts-dark-theme',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'all-charts-theme.json' },
  },
  
  {
    path: 'financial-metrics',
    component: DashboardComponent,
    data: { configFile: 'financial-metrics-poc.json' },
    canActivate: [AuthGuard],
  },
   {
    path: 'detailed_view',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'psbu_sales_overview.json' },
  },
   {
    path: 'europe-impact-report',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'europe-Impact-report.json' },
  },

  {
    path: 'chat',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'chat-config.json' },
  },
  {
    path: 'home',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'home-page.json' },
  },
  {
    path: 'approvals',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'approvals-hub.json' },
  },
  {
    path: 'approval-workflows',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'approval-workflows.json' },
  },
  {
    path: 'auth-configuration',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'auth-configuration.json' },
  },
  {
    path: 'deam-service',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'deam-service.json' },
  },
  {
    path: 'domain-catalogs',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'domain-catalogs.json' },
  },
  {
    path: 'customer-catalogs',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'customer-catalogs.json' },
  },
  {
    path: 'io-workflows',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'io-workflows.json' },
  },
  {
    path: '**',
    redirectTo: 'home',
  },
];


